export default "__VITE_ASSET__Csl26ZTu__"